import React from "react";
import {email, regex} from 'react-admin';
import {CreateGuesser, InputGuesser} from "@api-platform/admin";
import Title from "./Title";

export const validateEmail = email();
export const validatePassword = regex(
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/,
    'Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule, un chiffre, un caractère spécial et faire au moins 8 caractères.'
);

export default props => (
  <CreateGuesser {...props} title={<Title/>}>
    <InputGuesser source="email" label="Email" validate={validateEmail}/>
    <InputGuesser source="firstName" label="Prénom"/>
    <InputGuesser source="lastName" label="Nom" />
    <InputGuesser source="plainPassword" label="Mot de passe" validate={validatePassword} />
    <InputGuesser source="certificateUid" label="Identifiant certificat" />
  </CreateGuesser>
);
